import React from "react";
import { Link } from "react-router-dom";
import { MailOutlined } from "@ant-design/icons";
import { Logo } from "../../components/ui";
import styles from "./PublicAppHeader.module.css";

export const PublicAppHeader = () => {
  return (
    <header className={styles.header}>
      <Link to="/" className={styles.brand} aria-label="Quattro Support home">
        <Logo mobile />
        <span className={styles.brandText}>Quattro Support</span>
      </Link>
      <a className={styles.contact} href="mailto:info@quattroapps.com">
        <MailOutlined aria-hidden="true" />
        <span className={styles.contactLong}>Contact support</span>
        <span className={styles.contactShort}>Help</span>
      </a>
    </header>
  );
};
